import React from 'react';
import PropTypes from 'prop-types';

import EmptyStates from '../empty-states';
import withTranslate from '../../hoc/with-translate';

const MembersPlaceholder = ({ t, name }) => (
  <EmptyStates title={t('members-placeholder.title', { name })} content={t('members-placeholder.content')} noBoxClass />
);

MembersPlaceholder.propTypes = {
  t: PropTypes.func,
  name: PropTypes.string,
};

export default withTranslate(MembersPlaceholder);
